var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMoveVuln = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.49 0C26.323 0 27 .67 27 1.493v3.196c0 .823-.677 1.493-1.51 1.493H17.2v1.024h8.29c.833 0 1.51.67 1.51 1.493v3.196c0 .823-.677 1.493-1.51 1.493H17.2v1.025h1.883c.386 0 .7.31.7.692v.91h6.376c.386 0 .7.309.7.692a.696.696 0 0 1-.7.692h-6.376v.909a.696.696 0 0 1-.7.692h-5.166c-.386 0-.7-.31-.7-.692v-.909H6.842c-.387 0-.7-.31-.7-.692 0-.383.313-.693.7-.693h6.375v-.91c0-.382.314-.691.7-.691H15.8v-1.025H7.51c-.833 0-1.51-.67-1.51-1.493V8.699c0-.823.677-1.493 1.51-1.493h8.29V6.182H7.51c-.833 0-1.51-.67-1.51-1.493V1.493C6 .67 6.677 0 7.51 0Zm-7.107 15.797h-3.766v1.818h3.766v-1.818Zm7.107-7.206H7.51a.11.11 0 0 0-.11.108v3.196c0 .06.05.109.11.109h17.98a.11.11 0 0 0 .11-.11V8.7a.11.11 0 0 0-.11-.108Zm-1.71.9c.451 0 .816.36.816.806a.81.81 0 0 1-.815.806.81.81 0 0 1-.815-.806.81.81 0 0 1 .815-.806Zm1.71-8.106H7.51a.11.11 0 0 0-.11.108v3.196c0 .06.05.108.11.108h17.98a.11.11 0 0 0 .11-.108V1.493a.11.11 0 0 0-.11-.108Zm-1.71.9c.451 0 .816.36.816.806a.81.81 0 0 1-.815.806.81.81 0 0 1-.815-.806.81.81 0 0 1 .815-.806Z",
    fill: "#90A9C0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#90A9C0",
    strokeWidth: 1.3,
    fill: "#FFF",
    cx: 5,
    cy: 7,
    r: 4.35
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#90A9C0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 7h4M5 9l2-2M5 5l2 2"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoveVuln, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/moveVuln.f8f1d51a.svg";
export { ForwardRef as ReactComponent };